import FormPasswordChange from './FormPasswordChange'

export {
  FormPasswordChange
}


// WEBPACK FOOTER //
// ./src/components/FormPasswordChange/index.js